import type { Change } from '@gitbook/slate';

import { BLOCK_LIST_ITEM } from '../types';

/**
 * Remove a block by its key.
 */
export function removeBlock(change: Change, nodeKey: string): Change {
    const { value } = change;
    const { document } = value;
    const node = document.getNode(nodeKey);
    if (!node || node.object !== 'block') {
        return change;
    }
    if (node.type === BLOCK_LIST_ITEM) {
        const parent = document.getParent(nodeKey);
        if (parent?.nodes.size === 1) {
            return change.removeNodeByKey(parent.key);
        }
    }
    return change.removeNodeByKey(nodeKey);
}
